<!-- ! navigation bar will not be part of the final product -->
<div class="topbar-color fixed-top"></div>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top d-flex justify-content-between">
  <div class="navbar-brand" href="#">NaaS</div>

  <button class="btn-danger btn" (click)="clearSessionStorage()">Clear Session</button>
</nav>
